import GeneralPage from './GeneralPage';

export default GeneralPage;
